import React, { useState, useEffect, useRef } from "react";
import { keyframes } from "@mui/system";
import { Box, Typography, List } from "@mui/material";
import UserCard from "../../../Components/userCard";
import { useGetUsers } from "../../Utilisateur/Component/RecupererDonneeUser";
import UserDialog from "../../../Components/userDialog";
import { useUser } from "../../../Services/ContexteUser";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import KeyboardDoubleArrowUpOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowUpOutlined";

export default function UsersList() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const userRefs = useRef({}); // Références pour le scroll

  const { userData } = useUser(); // <-- récupère updateMonnaie pour MAJ contexte
  const usersD = useGetUsers();
  const usersData = usersD.usersData;

  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    if (userData?.statusUser) {
      setIsAdmin(userData.statusUser === "admin");
    }
  }, [userData]);

  useEffect(() => {
    if (usersData) {
      const usersArray = Object.values(usersData).sort(
        (a, b) => (b.nbMonnaie || 0) - (a.nbMonnaie || 0)
      );
      setUsers(usersArray);
    }
  }, [usersData]);

  const currentUser = userData;
  const userRanking =
    users.findIndex((user) => user.idUser === currentUser?.idUser) + 1;
  const isInTop3 = userRanking > 0 && userRanking <= 3;

  // Fonction pour scroller à la position de l'utilisateur
  const scrollToMyRanking = () => {
    if (userRanking && userRefs.current[userRanking - 1]) {
      userRefs.current[userRanking - 1].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  const handleOpenDialog = (user) => {
    setSelectedUser(user);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedUser(null);
  };

  const flicker = keyframes`
  0% { opacity: 0.1; transform: scale(0.90); }
  50% { opacity: 1; transform: scale(1); }
  100% { opacity: 0.1; transform: scale(0.90); }
`;

  const flicker2 = keyframes`
0% { opacity: 1; transform: scale(0.90); }
50% { opacity: 0.1; transform: scale(1); }
100% { opacity: 1; transform: scale(0.90); }
`;

  return (
    <Box sx={{ paddingTop: 30, position: "relative" }}>
      {/* --- BOUTON EN HAUT DE LA PAGE --- */}
      {/* {isAdmin && (
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 4000,
            background: "rgba(255,255,255,0.85)",
            backdropFilter: "blur(6px)",
            borderBottom: "1px solid rgba(90, 20, 121, 0.15)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 2,
          }}></Box>
      )} */}

      <Box sx={{ padding: 4 }}>
        {/* Podium */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end",
            gap: 0,
            marginBottom: 4,
          }}>
          {/* Couronne au-dessus du premier du classement */}
          {users[0] && (
            <EmojiEventsOutlinedIcon
              sx={{
                position: "absolute",
                top: 155,
                left: "50%",
                transform: "translateX(-50%)",
                fontSize: "4rem",
                color: "gold",
                zIndex: "1000",
              }}
            />
          )}
          {users[0] && (
            <EmojiEventsIcon
              sx={{
                position: "absolute",
                top: 155,
                left: "50%",
                transform: "translateX(-50%)",
                fontSize: "4rem",
                color: "rgba(90, 20, 121, 0.4)",
              }}
            />
          )}
          {/* Effet scintillant */}
          {users[0] && (
            <AutoAwesomeOutlinedIcon
              sx={{
                position: "absolute",
                top: 135,
                left: "52%",
                transform: "translateX(-50%) scaleX(-1)",
                fontSize: "2rem",
                color: "gold",
                animation: `${flicker} 1.5s infinite alternate`,
              }}
            />
          )}
          {users[0] && (
            <Box
              sx={{
                position: "absolute",
                top: 190,
                left: "43%",
                transform: "translateX(-50%) rotateY(180deg)",
              }}>
              <AutoAwesomeOutlinedIcon
                sx={{
                  fontSize: "1.4rem",
                  color: "gold",
                  animation: `${flicker2} 2s infinite alternate`,
                }}
              />
            </Box>
          )}
          {[1, 0, 2].map((index) =>
            users[index] ? (
              <Box
                key={users[index].id}
                sx={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  height:
                    index === 0 ? "240px" : index === 1 ? "200px" : "160px",
                  width: "200px",
                }}
                onClick={() => isAdmin && handleOpenDialog(users[index])}>
                {/* Ombre en arrière-plan */}
                <Box
                  sx={{
                    position: "absolute",
                    bottom: "100%",
                    width: "115%",
                    height: "40px",
                    background:
                      index === 0
                        ? "rgba(90, 20, 121, 0.4)"
                        : index === 1
                          ? "rgba(90, 20, 121, 0.3)"
                          : "rgba(90, 20, 121, 0.2)",
                    zIndex: 0,
                    clipPath:
                      index === 0
                        ? "polygon(15% 0%, 85% 0%, 100% 100%, 0% 100%)"
                        : index === 1
                          ? "polygon(20% 0%, 100% 0%, 100% 100%, 0% 100%)"
                          : "polygon(0% 0%, 80% 0%, 100% 100%, 0% 100%)",
                  }}
                />

                {/* Box Principale */}
                <Box
                  sx={{
                    position: "relative",
                    zIndex: 1000,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    height: "100%",
                    width: "100%",
                    background:
                      index === 0
                        ? "rgba(90, 20, 121)"
                        : index === 1
                          ? "rgba(90, 20, 121, 0.9)"
                          : "rgba(90, 20, 121, 0.7)",
                    borderRadius:
                      index === 0
                        ? "0px 0px 0px 0px"
                        : index === 1
                          ? "0px 0px 0px 8px"
                          : "0px 0px 8px 0px",
                    padding: 1,
                  }}>
                  <Typography
                    variant="h3"
                    sx={{
                      color: "#de91e5",
                      fontWeight: "bold",
                      fontSize: "4rem",
                      paddingBottom: index === 0 ? 12 : index === 1 ? 7 : 3,
                    }}>
                    {index + 1}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      color: "#de91e5",
                      fontWeight: "bold",
                    }}>
                    🤙 {users[index].nbMonnaie}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      textAlign: "center",
                      color: "#de91e5",
                      fontWeight: "bold",
                    }}>
                    {users[index].nomUser}
                  </Typography>
                </Box>
              </Box>
            ) : null
          )}
        </Box>

        {/* Section de l'utilisateur connecté (hors top 3) */}
        {!isInTop3 && currentUser && (
          <Box
            onClick={scrollToMyRanking}
            sx={{
              background: "rgba(90, 20, 121, 0.5)",
              marginBottom: 2,
              padding: 2,
              borderRadius: "10px",
              cursor: "pointer",
              "&:hover": { backgroundColor: "#ececec" },
              display: "flex",
              alignItems: "center",
              position: "relative",
              overflow: "hidden",
            }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexGrow: 1,
                zIndex: 1,
                width: "100%",
              }}>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "bold",
                  color: "#de91e5",
                  whiteSpace: "nowrap",
                }}>
                Place : {userRanking}
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  color: "#de91e5",
                  textAlign: "center",
                  flexGrow: 1,
                  margin: "0 20px",
                }}>
                {currentUser.nomUser?.length > 12
                  ? `${currentUser.nomUser.slice(0, 12)}...`
                  : currentUser.nomUser}
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontWeight: "bold",
                  color: "#de91e5",
                  whiteSpace: "nowrap",
                }}>
                🤙 {currentUser.nbMonnaie}
              </Typography>
            </Box>
          </Box>
        )}

        {/* Liste des utilisateurs (hors top 3) */}
        <List sx={{ paddingBottom: 5 }}>
          {users.slice(3).map((user, index) => (
            <Box key={user.id} ref={(el) => (userRefs.current[index + 3] = el)}>
              <UserCard
                user={user}
                onClick={() => isAdmin && handleOpenDialog(user)}
                index={index + 3}
              />
            </Box>
          ))}
        </List>
      </Box>

      {showScrollButton && (
        <Box
          onClick={scrollToTop}
          sx={{
            position: "fixed",
            zIndex: "3000",
            bottom: 80,
            right: 20,
            backgroundColor: "whitesmoke",
            color: "rgba(90, 20, 121)",
            width: 50,
            height: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
            cursor: "pointer",
          }}>
          <KeyboardDoubleArrowUpOutlinedIcon />
        </Box>
      )}

      {/* Dialog utilisateur */}
      {selectedUser && (
        <UserDialog
          open={dialogOpen}
          onClose={handleCloseDialog}
          user={selectedUser}
          setUsers={setUsers}
        />
      )}
    </Box>
  );
}
